/*
 * @Author: v_smwang
 * @Date: 2020-07-29 16:20:30
 * @LastEditors: v_smwang
 * @LastEditTime: 2020-08-18 15:00:22
 * @FilePath: \src\libs\MapAccount\TksAccout.js
 * @Description: 描述
 * @Module: 模块路径
 */
import { assert } from '@tencent/tks-utils/log';

const { mbcAccount } = window;

const ENV_LIST = ['dev', 'test', 'prod'];

export default class TksAccout {
  /**
   * @param {Object} options
   * @param {Promise} options.authPromise
   * @param {String} options.env
   * @param {String} options.ssoProxyPath
   * @param {String} options.platformId
   */
  constructor(options) {
    assert(
      ENV_LIST.includes(options.env),
      `arguments error: options.env=${options.env}`,
    );
    assert(
      options.authPromise,
      `arguments error: options.authPromise=${options.env}`,
    );
    assert(
      options.platformId,
      `arguments error: options.platformId=${options.platformId}`,
    );

    // eslint-disable-next-line no-param-reassign
    options = {
      authPromise: null,
      ssoProxyPath: `${window.location.origin}/mapssoproxy.html`,
      proxy: '',
      ...options,
    };
    this.options = options;
    this.response = null;

    this.setEnv(options.env);
  }

  setEnv(env) {
    mbcAccount.setEnv(env);
  }

  async getAuthorization() {
    if (this.response) {
      return Promise.resolve(this.response);
    }
    this.response = await this.options.authPromise(this.options, this);
    return this.response;
  }

  /**
   * 登出
   */
  logout(fail) {
    mbcAccount.logout({
      platformId: this.options.platformId,
      fail,
    });
  }

  apply() {
    mbcAccount.apply({
      platformId: this.options.platformId,
    });
  }

  /**
   * 跳转到登录页面
   */
  login() {
    mbcAccount.login({
      platformId: this.options.platformId,
      mapssoproxy: this.options.ssoProxyPath,
      include: 'qq,ioa',
      activeKey: 'qq',
    });
  }

  /**
   * 跳转到个人中心页面
   */
  jumpUserCenter() {
    mbcAccount.jumpUserCenter();
  }
}
